import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const bicValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const raw = (control.value ?? '').toString().trim();

  if (!raw) {
    return null;
  }

  const bic = raw.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

  if (!/^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/.test(bic)) {
    return {
      invalidBic: true,
      invalidBicMessage: 'BIC brukar vara 8 eller 11 tecken (t.ex. ESSESESS eller ESSESESSXXX)'
    };
  }

  return null;
};